import React, { useRef } from 'react';
import {
  Box,
  Flex,
  Menu,
  MenuButton,
  useBreakpointValue,
  MenuItem,
  Collapse,
  useDisclosure
} from '@chakra-ui/react';
import { FiChevronDown } from '@react-icons/all-files/fi/FiChevronDown';
import { GoTriangleUp } from '@react-icons/all-files/go/GoTriangleUp';
import Link from '@components/atoms/Link';
import { dataLayerClick } from '@helpers/dataLayerPush';
import HeaderFont from '@components/atoms/HeaderFont';

const SubMenu = ({ title = ``, links = [], ...props }) => {
  const parentRef = useRef(null);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleToggle = () => {
    if (!isOpen) {
      parentRef.current.focus();
      onOpen();
    } else {
      parentRef.current.blur();
      onClose();
    }
  };

  const handleLeaveParent = () => {
    parentRef.current.blur();
    onClose();
  };

  const handleLeaveSub = () => {
    onClose();
  };

  const handleHoverSub = () => {
    onOpen();
  };

  return (
    <Box {...props}>
      <Menu variant={{ base: `purpleSm`, md: `purple` }}>
        <MenuButton
          ref={parentRef}
          onClick={handleToggle}
          onMouseLeave={handleLeaveParent}
          lineHeight="1rem"
          bg={{ base: `transparent`, md: isOpen ? `gray.50` : `transparent` }}
          height={{ base: `3.5rem`, md: `5.125rem` }}
          _focus={{
            textDecoration: `none`
          }}
          _hover={{
            textDecoration: `none`
          }}>
          <Flex justify="space-between" alignItems="center" direction="row">
            {isMobile ? (
              <HeaderFont
                fontStyle="italic"
                color="white"
                fontWeight="900"
                textTransform="uppercase"
                fontSize="4xl"
                lineHeight="1"
                ml="2">
                {title}
              </HeaderFont>
            ) : (
              <Box> {title}</Box>
            )}
            <FiChevronDown
              ml="0.375rem"
              style={{
                transform: isOpen ? `rotate(180deg)` : `rotate(0deg)`
              }}
            />
          </Flex>
        </MenuButton>
        <Collapse
          style={{ overflow: `unset` }}
          in={isOpen}
          startingHeight="0"
          onMouseEnter={handleHoverSub}
          onMouseLeave={handleLeaveSub}>
          <Box
            minWidth="12.375rem"
            pt={{ base: `0`, md: `.6rem` }}
            bg="transparent"
            pos={{ base: `relative`, md: `absolute` }}>
            <Box
              as="span"
              w="100%"
              h="25px"
              pos="absolute"
              top="-0.7rem"
              left="0"
              pl=".5rem"
              cursor="pointer"
              onMouseEnter={handleHoverSub}
              display={{ base: `none`, md: `block` }}>
              <GoTriangleUp color="white" fontSize="2rem" />
            </Box>
            <Box boxShadow={{ base: `none`, md: `2xl` }}>
              {links.map((link) => {
                return (
                  <MenuItem
                    key={`${link.title}-${link.url}`}
                    variant={{ base: `sm`, md: `md` }}
                    sx={{
                      ':first-of-type .submenu-item': {
                        borderTopRadius: { base: `0`, md: `4px` }
                      },
                      ':last-of-type .submenu-item': {
                        borderBottomRadius: { base: `0`, md: `4px` }
                      }
                    }}>
                    <Link
                      className="submenu-item"
                      href={link.url}
                      width={{ base: `100%`, md: `100%` }}
                      p={{ base: `0`, md: `.75rem 0 .75rem 2rem` }}
                      variant={{ base: `subSm`, md: `sub` }}
                      boxShadow="none"
                      minWidth="12.375rem"
                      _focus={{
                        textDecoration: `none`
                      }}
                      _hover={{
                        textDecoration: `none`
                      }}
                      bg={{ base: `transparent`, md: `white` }}
                      onClick={() => {
                        dataLayerClick({
                          event: `nav_menu`,
                          clickText: link.title,
                          clickUrl: link.url
                        });
                      }}>
                      {isMobile ? (
                        <HeaderFont
                          fontStyle="italic"
                          color="white"
                          fontWeight="900"
                          textTransform="uppercase"
                          fontSize="xl"
                          lineHeight="1"
                          ml="3">
                          {link.title}
                        </HeaderFont>
                      ) : (
                        <Box> {link.title}</Box>
                      )}
                    </Link>
                  </MenuItem>
                );
              })}
            </Box>
          </Box>
        </Collapse>
      </Menu>
    </Box>
  );
};

export default SubMenu;
